import React from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import {
  voidItemReportChangeFilter,
  voidItemReportExport,
} from 'actions/tableManagement/voidItem';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar';
import MenuTitle from 'components/MenuTitle';
import LineNavbar from 'components/LineNavbar';
import ActionBarWrapper from 'components/wrappers/pages/ActionBarWrapper';
import { getFormattedTime } from 'utils/hourFilter';
import { tableVoidItemReportExport } from 'clevertap/tableManagement';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    const { outlets } = this.props;

    const navigations = [
      { href: '/table-management/report', label: 'Transaction' },
      { href: '/table-management/void-item-report', label: 'Void Items' },
    ];
    return (
      <div className={styles.wrapper}>
        <MenuTitle menuTitle="Table Report" />

        <div
          className="col-sm-2 hidden-xs col-md-6 action-table-management"
          style={{ paddingRight: 0 }}
        >
          <span className="pull-right">
            <button
              className="btn btn-primary"
              onClick={this._onClickExport}
              id="export-void-item"
            >
              Export
            </button>
          </span>
        </div>

        <ActionBarWrapper>
          <div className={`col-sm-12 col-xs-12 ${styles['action-bar']}`}>
            <div className={styles['btn-outlet']}>
              <Field
                name="outletIds"
                component={DropdownOutlet}
                outlets={outlets}
                onChangeOutletIds={this._onChangeOutletIds}
              />
            </div>
            <div className={styles['btn-search']}>
              <Field
                component={DropdownCalendar}
                name="date"
                onChange={this._onChangeDate}
                updateServerOnChange
              />
            </div>
          </div>
        </ActionBarWrapper>
        <div className="row">
          <div className="col-xs-12">
            <LineNavbar
              links={navigations}
              pathname={this.props.location.pathname}
            />
          </div>
        </div>
      </div>
    );
  }

  _onChangeOutletIds = outletIds => {
    const { dispatch, search } = this.props;
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
    } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const payload = {
      outletIds,
      startDate: formattedStart,
      endDate: formattedEnd,
    };

    dispatch(voidItemReportChangeFilter(payload));
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { dispatch, search } = this.props;
    const { outletIds } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const payload = {
      outletIds,
      startDate: formattedStart,
      endDate: formattedEnd,
    };

    dispatch(voidItemReportChangeFilter(payload));
  };

  _onClickExport = () => {
    const { outlets, dispatch, search } = this.props;
    const {
      outletIds,
      date: { startDate, endDate, startHour, endHour, allDay },
    } = search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const outletName = findOutletName(outlets, outletIds[0]);
    const payload = {
      outletIds,
      startDate: formattedStart,
      endDate: formattedEnd,
      outletName,
    };
    const clevertabPayload = {
      outletIds: outletIds[0],
      startDate,
      endDate,
      allDay,
    };

    dispatch(voidItemReportExport(payload));
    tableVoidItemReportExport(clevertabPayload);
  };
}

const mapForm = { form: 'search' };

function findOutletName(outlets, currentOutlet) {
  const outlet = outlets.reduce(function(filtered, outlet) {
    if (outlet.id === currentOutlet) {
      filtered.push(outlet);
    }
    return filtered;
  }, []);
  return outlet[0].name;
}

function mapStateToProps(state) {
  return {
    outlets: state.tableManagement.voidItem.outlets,
    userPropertiesLoaded: state.userProperties.loaded,
    search: getFormValues('search')(state),
  };
}

export default reduxForm(mapForm)(connect(mapStateToProps)(ActionBar));
